import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, Layout } from 'lucide-react';


const SideBar = () => {
    const navigation = [
        { name: 'Home', path: '/dashboard', icon: <Home size={20} /> },
        { name: 'Leads', path: '/dashboard/leads', icon: <Users size={20} /> },
        { name: 'Projects', path: '/dashboard/projects', icon: <Layout size={20} /> },
        { name: 'Services', path: '/dashboard/services', icon: <Layout size={20} /> },
    ];

    return (
        <aside className="flex flex-col w-64 h-screen bg-gray-900 text-gray-100 border-r border-gray-800">
            <div className="flex items-center gap-3 p-6 mb-4">
                <div className="p-2 bg-white rounded-lg w-10 h-10 overflow-visible">
                    <img
                        src="/Projectlocklogowhitebg.PNG"
                        alt=""
                        className="object-contain w-full scale-150"
                    />
                </div>
                <span className="text-xl font-bold tracking-wide">ProjectLock</span>
            </div>

            <nav className="flex-1 px-4 space-y-2">
                {navigation.map((item) => (
                    <NavLink
                        key={item.name}
                        to={item.path}
                        end
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${isActive
                                ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20'
                                : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                            }`
                        }
                    >
                        <span className="shrink-0">{item.icon}</span>
                        <span className="font-medium">{item.name}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="p-4 border-t border-gray-800">
                <div className="flex items-center gap-3 p-2 bg-gray-800/40 rounded-lg">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-blue-500 to-indigo-600 shrink-0" />
                    <div className="overflow-hidden">
                        <p className="text-sm font-medium truncate">Admin User</p>
                        <p className="text-xs text-gray-500 truncate">admin@lock.com</p>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default SideBar;
